import _ from 'lodash';

const templateConfig = { interpolate: /{{([\s\S]+?)}}/g };

/**
 * @param template {String}
 */
export const templateString = template => _.template(template, templateConfig);
